import React from "react";
import { useNavigate } from "react-router-dom";
import "../Category/CategorySection.css";

const categories = [
  { name: "Gardening", image: "s1.webp" },
  { name: "Plants", image: "s2.webp" },
  { name: "Seeds", image: "s3.webp" },
  { name: "Bulbs", image: "s1.webp" },
  { name: "Pots", image: "s2.webp" },
  { name: "Fertilizers", image: "s3.webp" },
  { name: "Corporate", image: "s1.webp" },
  { name: "Pebbles", image: "s2.webp" },
  { name: "Accessories", image: "s3.webp" },
];

const CategorySection = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/products/${category}`);
  };

  return (
    <div className="category-section">
      {categories.map((cat) => (
        <div
          key={cat.name}
          className="category-item"
          onClick={() => handleCategoryClick(cat.name.toLowerCase())}
        >
          <img src={cat.image} alt={cat.name} className="category-image" />
          <p className="category-name">{cat.name}</p>
        </div>
      ))}
    </div>
  );
};

export default CategorySection;
